<template>
  <div class="grid grid-cols-1 md:grid-cols-3 mx-auto my-8 w-full px-8 gap-4">
    <PartnerImageLink
      :partner-link="partnerLink"
      link="http://teamtrackonline.com"
      image-src="/images/TeamTrack_logo.png"
      :link-class="linkClass"
      :image-class="imageClass"
    />
    <PartnerImageLink
      :partner-link="partnerLink"
      link="http://usa.anubesport.com/stella"
      image-src="/images/Stella-Anubeb184.jpg"
      :link-class="linkClass"
      :image-class="imageClass"
    />
    <PartnerImageLink
      :partner-link="partnerLink"
      link="http://rallysafe.com.au"
      image-src="/images/rallysafe_28141.png"
      :link-class="linkClass"
      :image-class="imageClass"
    />
  </div>
  <div class="grid grid-cols-1 md:grid-cols-3 mx-auto my-8 w-full px-8 gap-4">
    <PartnerImageLink
      :partner-link="partnerLink"
      link="http://www.ybtracking.com"
      image-src="/images/yb-tracking-yellow-brick-tracking-logo.jpg"
      :link-class="linkClass"
      :image-class="imageClass"
    />
    <PartnerImageLink
      :partner-link="partnerLink"
      link="http://www.rbi-sport.com/"
      image-src="/images/GeoTraq303d.png"
      :link-class="linkClass"
      :image-class="imageClass"
    />
    <PartnerImageLink
      :partner-link="partnerLink"
      link="http://www.racingtrax.com"
      image-src="/images/RacingTraxcaaf.png"
      :link-class="linkClass"
      :image-class="imageClass"
    />
  </div>
  <div
    class="mx-auto my-8 flex flex-col md:flex-row w-full justify-between px-8 gap-2"
  >
    <PartnerImageLink
      :partner-link="partnerLink"
      link="http://www.sporttraxx.com"
      image-src="/images/Sporttraxx805f.png"
      :link-class="linkClass"
      :image-class="imageClass"
    />
    <PartnerImageLink
      :partner-link="partnerLink"
      link="http://rallycomp.weebly.com"
      image-src="/images/rallycomplogolong_11_orig.png"
      :link-class="linkClass"
      :image-class="imageClass"
    />
    <PartnerImageLink
      :partner-link="partnerLink"
      link="http://www.vdsracing.com/MOTOR_SPORTS_TRACKING.e.htm"
      image-src="/images/VDS-RACINGc638.jpg"
      :link-class="linkClass"
      :image-class="imageClass"
    />
  </div>
  <div class="grid grid-cols-1 md:grid-cols-3 mx-auto my-8 w-full px-8 gap-4">
    <PartnerImageLink
      :partner-link="partnerLink"
      link="https://www.ertf.com/en/expert-in-rallye-raid-baja-equipment/"
      image-src="/images/ERTF-Competition.png"
      :link-class="linkClass"
      :image-class="imageClass"
    />
    <PartnerImageLink
      :partner-link="partnerLink"
      link="http://www.terrapirata.com"
      image-src="/images/download/terrapirata_BLACK_SMOOTH.png"
      :link-class="linkClass"
      :image-class="imageClass"
    />
  </div>
</template>

<script>
import PartnerImageLink from './PartnerImageLink.vue';

export default {
  name: 'PartnersStandard',
  data() {
    return {
      linkClass:
        'w-full max-w-[300px] max-h-[200px] mx-auto object-contain h-auto',
      imageClass:
        'object-contain w-full h-full flex items-center justify-center mx-auto',
    };
  },
  components: {
    PartnerImageLink,
  },
  props: {
    partnerLink: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
